import './index.scss'
import Pro1 from '../../../assets/images/pro_img1.png'
import Pro2 from '../../../assets/images/pro_img2.png'
import Pro3 from '../../../assets/images/pro_img3.png'
import Pro4 from '../../../assets/images/pro_img4.png'

const Forclick = () => {
  return (
    <div className="projects">
      <img className="pro1" src={Pro1} alt="Painter with VanliaJS" />
      <div className="painter">
        <a
          href="https://s1romy.github.io/painterwithjs/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h2>Painter</h2>
        </a>
        <hr />
        <h4>
          Skills: <br />
          HTML / CSS / JavaScript
        </h4>
      </div>
      <img className="pro2" src={Pro2} alt="Converters" />
      <div className="converters">
        <a
          className="pro2-a"
          href="https://s1romy.github.io/converter_0325/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h2>Converter</h2>
        </a>
        <hr />
        <h4>
          Skills: <br />
          HTML / CSS / JavaScript
        </h4>
      </div>
      <img className="pro3" src={Pro3} alt="Browser App" />
      <div className="browserapp">
        <a
          className="pro3-a"
          href="https://s1romy.github.io/browserapp/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h2>Browser App</h2>
        </a>
        <hr />
        <h4>
          Skills: <br />
          HTML / CSS / JavaScript
        </h4>
      </div>
      <img className="pro4" src={Pro4} alt="First Portfolio" />
      <div className="portfolio">
        <a
          href="s1romy.github.io"
          className="pro4-a"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h2>Portfolio Website</h2>
        </a>
        <hr />
        <h4>
          Skills: <br />
          HTML / SASS / React
        </h4>
      </div>
    </div>
  )
}

export default Forclick
